/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: 1625
 * 创建日期 2021/03/09
 */
import request from 'crm/utils/request'
import {format} from 'utils'
import api from './api'

export async function getOverview(params) {
    return request(`${format(api.overview.url, {id: params.id})}`)
}
export async function getDetail(params) {
    return request(`${format(api.detail.url, {id: params.id})}`)
}
